import { render, staticRenderFns } from "./addPosition.vue?vue&type=template&id=95e9046a&"
import script from "./addPosition.vue?vue&type=script&lang=js&"
export * from "./addPosition.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports